export default "__VITE_ASSET__azh1xeAu__"